import request from '@/utils/request'

let SmrzApi = {

  /*实名认证列表*/
  list(data) {
    return request._post('/shop/plus.smrz.Index/index', data);
},
/*添加实名认证*/
add(data) {
    return request._post('/shop/plus.smrz.Index/add', data);
},
audit(data){
    return request._post('/shop/plus.smrz.Index/audit', data);
},
/*修改实名认证*/
edit(data) {
    return request._post('/shop/plus.smrz.Index/edit', data);
},
/*删除实名认证*/
del(data) {
    return request._post('/shop/plus.smrz.Index/del', data);
},
/*实名认证详情*/
detail(data) {
  return request._post('/shop/plus.smrz.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.smrz.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.smrz.Setting/getSetting', data, errorback);
    },
}
export default SmrzApi;



// WEBPACK FOOTER //
// ./src/api/smrz.js